<template>
	<c-dialog ref="dialog" title="评价详情" :button="false" mask-close>
		<c-detail style="padding: 0;">
			<c-detail-item label="服务评分">
				<div class="flex-start-center" style="gap: .08rem; font-size: .26rem;">
					<ins v-for="(item, i) in detailInfo.service_score" :key="i" style="color: #FF6900;">
						<i class="tf">&#xe71e;</i>
					</ins>
				</div>
			</c-detail-item>
			<c-detail-item label="服务评语">{{detailInfo.evaluation_tags ? detailInfo.evaluation_tags.replaceAll(',', '、') : '无'}}</c-detail-item>
			<c-detail-item label="图片">
				<c-file-list :value="detailInfo.evaluation_images"></c-file-list>
			</c-detail-item>
			<c-detail-item label="评价内容">
				<div style="min-height: 3rem;">{{detailInfo.evaluation_content || '无'}}</div>
			</c-detail-item>
		</c-detail>
	</c-dialog>
</template>

<script>
	export default {
		name: 'appraiseDetail',

		props: {
			id: [Number, String]
		},
		
		data() {
			return {
				detailInfo: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/after/sale/order/evaluation/detail',
					data: {
						order_id: this.id
					},
					loading: true,
					success: data => {
						this.detailInfo = data;
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>